import React from 'react';

import PropTypes from 'prop-types';

import { ANSWER_VALIDATION } from 'components/modules/questions/constants';
import { AnswerType } from 'components/modules/questions/types';

import AnswerItem from '../AnswerItem';

const propTypes = {
  answers: PropTypes.arrayOf(AnswerType).isRequired,
  answerErrors: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string })),
  onAnswerChange: PropTypes.func.isRequired,
  onAnswerDelete: PropTypes.func.isRequired,
  onPreferredChange: PropTypes.func.isRequired,
};

const defaultProps = {
  answerErrors: [],
};

function AnswersList({ answers, answerErrors, onAnswerChange, onAnswerDelete, onPreferredChange }) {
  return (
    <div className="answers-list">
      {answers.map((answer, idx) => {
        return (
          <AnswerItem
            key={answer.id}
            answer={answer}
            index={idx}
            answerErrors={answerErrors && answerErrors[idx]}
            onAnswerChange={onAnswerChange}
            onAnswerDelete={onAnswerDelete}
            onPreferredChange={onPreferredChange}
            canDelete={answers.length > ANSWER_VALIDATION.MIN_ANSWERS}
            isPreferred={answer.isPreferred}
          />
        );
      })}
    </div>
  );
}

AnswersList.propTypes = propTypes;
AnswersList.defaultProps = defaultProps;

export default AnswersList;
